import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'itwiththebest';
  constructor(
    public translate: TranslateService
  ) {
    translate.addLangs(['en', 'ro'])
    translate.setDefaultLang('en');

    var language = localStorage.getItem("language");
    var languageToBeUsed = language && language.match(/en|ro/) ? language : 'en';
    
    translate.use(languageToBeUsed);
    localStorage.setItem("language", languageToBeUsed);
  }
}
